import type { ApiJobId } from '#/api/types/ApiTypedId';
import type { ApiJob } from '#/modules/listing/jobs/api/types/ApiJob';
import type { ApiUnpublishedJob } from '#/modules/listing/jobs/api/types/ApiUnpublishedJob';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  data: ApiJob | ApiUnpublishedJob;
};

function mapResponse(response: ApiResponse): ApiJob | ApiUnpublishedJob {
  return response.data;
}

const embedWidgetEndpoint = new FetchEndpoint({
  urlFactory: (embedSearchWidgetId: string, jobId: ApiJobId) =>
    `/data/embed-search-widgets/${embedSearchWidgetId}/jobs/${jobId}`,
  mapResponse,
});

// Exports

export const embedSearchWidgetApiIsomorphicFetchJob =
  embedWidgetEndpoint.createIsomorphicFetchFn();
